export const truncuateString = (data, length) => `${data.substr(0, length)}...`;

export function hashStringToObject(hash) {
  const value = {};
  hash
    .substring(1)
    .split("&")
    .map(str => (value[str.split("=")[0]] = str.split("=")[1]));
  return value;
}
